import React from 'react'
import copy from 'copy-to-clipboard'
import { useSelector } from 'react-redux'

import { DashboardLayout, Icon, Qr, ThemeIcon } from '../../../components'

import './ReceiveCoin.scss'
import clsx from 'clsx'

const ReceiveCoin = ({ onBackClick, unit }) => {
   const { publicKey } = useSelector(state => state.user)
   const { isDarkTheme } = useSelector(state => state.theme)

   const CODE = publicKey

   const shareCode = () =>
      navigator
         .share({
            title: 'WallStreetNinja',
            text: CODE,
         })
         .then(() => {
            console.log('Shared!')
         })
         .catch(err => {
            console.log('Error when sharing!')
         })

   return (
      <DashboardLayout
         withNav={false}
         className={clsx('ReceiveCoin', isDarkTheme && 'ReceiveCoin--dark')}
      >
         <header className="ReceiveCoin__header">
            <Icon
               className="ReceiveCoin__header-back"
               name="chevron-left"
               onClick={onBackClick}
            />
            Receive {unit}
         </header>
         <div className="ReceiveCoin__card">
            <h3 className="ReceiveCoin__card-title">WallStreetNinja</h3>
            <Qr
               className="ReceiveCoin__card-qr"
               code={CODE}
               width={238}
               isDarkTheme={isDarkTheme}
            />
            <small className="ReceiveCoin__card-code">{CODE}</small>
         </div>
         <p className="ReceiveCoin__warning">
            Send only <span className="ReceiveCoin__warning-unit">{unit}</span>{' '}
            to this address. Sending any other coins may result in permanent
            loss.
         </p>
         <div className="ReceiveCoin__actions">
            <ThemeIcon
               className="ReceiveCoin__actions-icon"
               name="clone"
               onClick={() => copy(CODE)}
            />
            {!!navigator.share && (
               <ThemeIcon
                  className="ReceiveCoin__actions-icon"
                  name="share"
                  onClick={shareCode}
               />
            )}
         </div>
      </DashboardLayout>
   )
}

export default ReceiveCoin
